(function () {
  'use strict';

  // ── Guard ──────────────────────────────────────────────────────────────────
  if (!window.cvfRaw || !window.cvfRaw.length) return;

  // ── Deduplicate by URL, merging products ───────────────────────────────────
  var videoMap = new Map();
  window.cvfRaw.forEach(function (item) {
    if (!item.url) return;
    if (videoMap.has(item.url)) {
      var entry = videoMap.get(item.url);
      if (!entry.products.some(function (p) { return p.url === item.product.url; })) {
        entry.products.push(item.product);
      }
    } else {
      videoMap.set(item.url, { url: item.url, products: [item.product] });
    }
  });
  var videos = Array.from(videoMap.values());
  if (!videos.length) return;

  // ── DOM refs ───────────────────────────────────────────────────────────────
  var modal = document.getElementById('cvf-modal');
  var slidesContainer = document.getElementById('cvf-modal-slides');
  var closeBtn = document.getElementById('cvf-modal-close');
  var counterEl = document.getElementById('cvf-modal-counter');
  if (!modal || !slidesContainer || !closeBtn) return;

  var countLabel = document.getElementById('cvf-count');
  if (countLabel) countLabel.textContent = videos.length + ' video' + (videos.length !== 1 ? 's' : '');

  // ── Story tile — autoplay muted video preview, fallback to image ──────────
  var ringInner = document.getElementById('cvf-story-ring-inner');
  if (ringInner && videos[0]) {
    var firstImage = videos[0].products[0].image;
    var previewVid = document.createElement('video');
    previewVid.src = videos[0].url;
    previewVid.autoplay = true;
    previewVid.muted = true;
    previewVid.loop = true;
    previewVid.playsInline = true;
    previewVid.setAttribute('playsinline', '');
    previewVid.setAttribute('preload', 'metadata');
    if (firstImage) previewVid.poster = firstImage;
    previewVid.style.pointerEvents = 'none';
    previewVid.play().catch(function () {
      // Autoplay blocked — swap in the poster image instead
      if (firstImage) {
        var img = document.createElement('img');
        img.src = firstImage;
        img.alt = videos[0].products[0].title;
        ringInner.replaceChild(img, previewVid);
      }
    });
    ringInner.appendChild(previewVid);
  }

  var storyRing = document.getElementById('cvf-story-ring');
  if (storyRing) {
    storyRing.addEventListener('click', function () {
      var firstSlide = slidesContainer.children[0];
      if (firstSlide) {
        var vid = firstSlide.querySelector('.cvf-slide-video');
        if (vid && !vid.getAttribute('src') && vid.dataset.src) vid.src = vid.dataset.src;
        if (vid) { vid.muted = isMuted; vid.play().catch(function () {}); }
      }
      openModal(0);
    });
    storyRing.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(0); }
    });
  }

  // ── Build overlay HTML ─────────────────────────────────────────────────────
  function buildOverlay(video, hasMultiple) {
    var primary = video.products[0];

    // Multiple products share this video — chips only, no ATC (ambiguous)
    if (hasMultiple) {
      var chipsHtml = video.products.map(function (p) {
        return '<a class="cvf-slide-chip" href="' + esc(p.url) + '">' + esc(p.title) + '</a>';
      }).join('');
      return '<div class="cvf-slide-also-label">Also available in:</div>' +
        '<div class="cvf-slide-chips">' + chipsHtml + '</div>' +
        '<a href="' + esc(primary.url) + '" class="cvf-slide-view-btn">View Product &rarr;</a>';
    }

    var titleHtml = '<div class="cvf-slide-product-title">' + esc(primary.title) + '</div>';

    // Multiple option types — go to product page to choose
    if (!primary.def && !primary.single) {
      return titleHtml +
        '<div class="cvf-slide-product-price">' + esc(primary.price) + '</div>' +
        '<a href="' + esc(primary.url) + '" class="cvf-slide-view-btn">View Product &rarr;</a>';
    }

    // First available variant
    var firstVariant = primary.vts && primary.vts.length
      ? (primary.vts.find(function (v) { return v.ok; }) || primary.vts[0])
      : null;
    var variantId = firstVariant ? firstVariant.id : '';
    var variantPrice = firstVariant ? firstVariant.p : primary.price;

    var cartIcon = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
    var atcBtn = '<button class="cvf-slide-atc-btn" data-variant-id="' + variantId + '">' + cartIcon + 'Add to Cart</button>';
    var viewBtn = '<a href="' + esc(primary.url) + '" class="cvf-slide-view-btn cvf-view-secondary">View &rarr;</a>';
    var actionsRow = '<div class="cvf-slide-actions">' + atcBtn + viewBtn + '</div>';

    // No real variants — direct ATC
    if (primary.def) {
      return titleHtml +
        '<div class="cvf-slide-product-price">' + esc(primary.price) + '</div>' +
        actionsRow;
    }

    // Single option — variant buttons + price updates + ATC + View
    var variantBtns = primary.vts.map(function (vt) {
      var isActive = firstVariant && vt.id === firstVariant.id;
      return '<button class="cvf-variant-btn' + (isActive ? ' active' : '') + (!vt.ok ? ' out-of-stock' : '') + '" ' +
        'data-variant-id="' + vt.id + '" data-price="' + esc(vt.p) + '"' +
        (!vt.ok ? ' disabled' : '') + '>' + esc(vt.t) + '</button>';
    }).join('');

    return titleHtml +
      '<div class="cvf-slide-product-price">' + esc(variantPrice) + '</div>' +
      '<div class="cvf-slide-variants">' + variantBtns + '</div>' +
      actionsRow;
  }

  // ── Build modal slides ─────────────────────────────────────────────────────
  videos.forEach(function (video, index) {
    var primary = video.products[0];
    var hasMultiple = video.products.length > 1;

    var slide = document.createElement('div');
    slide.className = 'cvf-slide';
    slide.dataset.index = index;

    slide.innerHTML =
      '<video class="cvf-slide-video" data-src="' + esc(video.url) + '" poster="' + esc(primary.image || '') + '" preload="none" loop muted playsinline></video>' +
      '<div class="cvf-slide-tap-area"></div>' +
      '<div class="cvf-slide-pause-icon">' +
        '<svg width="30" height="30" viewBox="0 0 24 24" fill="white">' +
          '<rect x="5" y="3" width="4" height="18" rx="1"/>' +
          '<rect x="15" y="3" width="4" height="18" rx="1"/>' +
        '</svg>' +
      '</div>' +
      '<div class="cvf-slide-overlay">' + buildOverlay(video, hasMultiple) + '</div>' +
      (index === 0 ?
        '<div class="cvf-swipe-hint">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="18 15 12 9 6 15"/></svg>' +
          'Swipe up' +
        '</div>' : '');

    // Tap video to pause / play
    slide.querySelector('.cvf-slide-tap-area').addEventListener('click', function () {
      var v = slide.querySelector('.cvf-slide-video');
      if (v.paused) { v.play().catch(function () {}); slide.classList.remove('is-paused'); }
      else { v.pause(); slide.classList.add('is-paused'); }
    });

    // Variant selection — updates price + ATC target variant
    if (!hasMultiple && primary.single) {
      var priceEl = slide.querySelector('.cvf-slide-product-price');
      var atcBtnEl = slide.querySelector('.cvf-slide-atc-btn');
      slide.querySelectorAll('.cvf-variant-btn').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          slide.querySelectorAll('.cvf-variant-btn').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          if (priceEl) priceEl.textContent = btn.dataset.price;
          if (atcBtnEl) atcBtnEl.dataset.variantId = btn.dataset.variantId;
        });
      });
    }

    // Add to Cart
    var atcBtnEl = slide.querySelector('.cvf-slide-atc-btn');
    if (atcBtnEl) {
      atcBtnEl.addEventListener('click', function (e) {
        e.stopPropagation();
        var vid = parseInt(atcBtnEl.dataset.variantId, 10);
        if (vid) addToCart(vid, atcBtnEl);
      });
    }

    slidesContainer.appendChild(slide);
  });

  // ── Add to Cart — uses the theme's cart-provider event system ───────────────
  function addToCart(variantId, btn) {
    btn.disabled = true;
    var origHtml = btn.innerHTML;
    btn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" style="flex-shrink:0;animation:cvf-spin 0.7s linear infinite"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg> Adding...';

    // Listen once for the theme's cart:update or cart:error response
    function onSuccess() {
      cleanup();
      btn.innerHTML = '&#10003; Added!';
      btn.classList.add('is-added');
      setTimeout(function () {
        btn.innerHTML = origHtml;
        btn.classList.remove('is-added');
        btn.disabled = false;
      }, 2500);
    }

    function onError() {
      cleanup();
      btn.innerHTML = origHtml;
      btn.disabled = false;
    }

    function cleanup() {
      document.removeEventListener('cart:update', onSuccess, true);
      document.removeEventListener('cart:error', onError, true);
    }

    document.addEventListener('cart:update', onSuccess, { capture: true, once: true });
    document.addEventListener('cart:error', onError, { capture: true, once: true });

    // Dispatch to the theme's cart-provider — it handles updating
    // the drawer, cart counter, and notification automatically
    document.dispatchEvent(new CustomEvent('cart:add', {
      bubbles: false,
      cancelable: true,
      composed: true,
      detail: {
        sectionId: null,
        data: { items: [{ id: variantId, quantity: 1 }] }
      }
    }));
  }

  // ── IntersectionObserver — autoplay/pause on swipe ────────────────────────
  var slideObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var slide = entry.target;
      var v = slide.querySelector('.cvf-slide-video');
      var idx = parseInt(slide.dataset.index, 10);
      if (!v) return;

      if (entry.isIntersecting) {
        if (v.dataset.src && !v.getAttribute('src')) v.setAttribute('src', v.dataset.src);
        v.muted = isMuted;
        v.play().catch(function () {});
        slide.classList.remove('is-paused');
        if (counterEl) counterEl.textContent = (idx + 1) + ' / ' + videos.length;
      } else {
        v.pause();
        v.currentTime = 0;
        slide.classList.remove('is-paused');
      }
    });
  }, { threshold: 0.5 });

  // ── Open modal ─────────────────────────────────────────────────────────────
  function openModal(startIndex) {
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    if (counterEl) counterEl.textContent = (startIndex + 1) + ' / ' + videos.length;
    Array.from(slidesContainer.querySelectorAll('.cvf-slide')).forEach(function (s) {
      slideObserver.observe(s);
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var target = slidesContainer.children[startIndex];
        if (target) { target.scrollIntoView({ behavior: 'instant' }); target.classList.remove('is-paused'); }
      });
    });
  }

  // ── Close modal ────────────────────────────────────────────────────────────
  function closeModal() {
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    Array.from(slidesContainer.querySelectorAll('.cvf-slide')).forEach(function (s) {
      slideObserver.unobserve(s);
      var v = s.querySelector('.cvf-slide-video');
      if (v) { v.pause(); v.currentTime = 0; }
      s.classList.remove('is-paused');
    });
  }

  closeBtn.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();
  });

  // ── Mute toggle ────────────────────────────────────────────────────────────
  var isMuted = true;
  var muteBtn = document.getElementById('cvf-modal-mute');
  var iconMuted = document.getElementById('cvf-icon-muted');
  var iconSound = document.getElementById('cvf-icon-sound');

  if (muteBtn) {
    muteBtn.addEventListener('click', function () {
      isMuted = !isMuted;
      // Update all slide videos
      slidesContainer.querySelectorAll('.cvf-slide-video').forEach(function (v) {
        v.muted = isMuted;
      });
      // Swap icons
      if (iconMuted) iconMuted.style.display = isMuted ? '' : 'none';
      if (iconSound) iconSound.style.display = isMuted ? 'none' : '';
    });
  }


  // ── Helper: HTML escape ────────────────────────────────────────────────────
  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

})();
